import React from 'react';

import LeaseItem from './LeaseItem';

import { localize } from 'react-localize-redux';

class LeaseItems extends React.Component {
  state = { dialogOpen: false };

  render() {
    return (
      <div>
        <h5 style={{ padding: '20px 16px 0' }}>{this.props.translate('leaseItems.additional')}</h5>

        {this.renderLeaseCharges(this.props.leaseCharges)}
      </div>
    );
  }

  renderLeaseCharges(leaseCharges = []) {
    if (!leaseCharges.length) {
      return (
        <div className="col-xs-12">
          <p>{this.props.translate('leaseItems.noLeaseItems')}</p>
        </div>
      );
    }

    return <div>{leaseCharges.map(item => <LeaseItem item={item} />)}</div>;
  }
}

export default localize()(LeaseItems);
